export default __webpack_public_path__ + "static/media/JamesWood.e99c32e2.png";